import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import DeliveryChargeIcon from "../../Icons/DeliveryChargeIcon";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import Spinner from "../../components/Reusable/Spinner";
import Skeleton from "../../components/Reusable/Skeleton";
const DeliveryChargeListComponent = loadable(
  () => import("../../components/DeliveryCharge")
);

const DeliveryCharge = () => {
  const {
    data: merchant,
    refetch,
    isLoading: isBranchLoading,
  } = useGetHook({
    queryKey: ["local-branch"],
    url: `${APIS.BRANCH}`,
    params: {},
  });

  const { data: Service, isLoading: isServiceLoading } = useGetHook({
    queryKey: ["local-service"],
    url: `${APIS.SERVICE_TYPE}`,
    params: {},
  });
  const { data: productData, isLoading: isProductLoading } = useGetHook({
    queryKey: ["local-product"],
    url: `${APIS.PRODUCT_TYPE}`,
    params: {},
  });

  const { data: currentMerchantProfile, isLoading: isMerchantProfileLoading } =
    useGetHook({
      queryKey: [`current-merchant-profile`],
      url: `${APIS.CURRENT_MERCHANT}`,
      params: {},
    });

  return (
    <>
      <div>
        <div
          className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
        >
          <DeliveryChargeIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>
            Delivery Charge
          </span>
        </div>
        {isBranchLoading ||
        isServiceLoading ||
        isProductLoading ||
        isMerchantProfileLoading ? (
          <Skeleton />
        ) : (
          <DeliveryChargeListComponent
            branch={merchant}
            service={Service}
            product={productData}
            currentMerchantProfile={currentMerchantProfile}
          />
        )}
      </div>
    </>
  );
};

export default DeliveryCharge;
